<template>
    <div>
        <div class="flex items-center justify-between mb-3">
            <h2 class="text-2xl">Entrypoints</h2>

            <button v-if="!showForm" @click="showForm = !showForm" class="group bg-white px-3 py-2 rounded text-teal-800 hover:text-teal-200 hover:bg-teal-800">
                <i class="fal mr-1 fa-plus"></i>Add
            </button>
        </div>

        <form v-if="showForm" @submit.prevent="submitEntrypoint" class="bg-white px-5 py-3 rounded-lg shadow-lg mb-5 flex items-center">
            <text-input v-model="form.url" :errors="$page.props.errors.url" class="mb-3 flex-grow" label="URL" />
            <button type="submit" class="mt-5 text-white bg-teal-700 px-5 py-2 ml-3 rounded inline-block hover:bg-teal-800 focus:bg-teal-800">
                <i class="fal mr-1" :class="loading == 'submitEntrypoint' ? 'fa-spinner fa-spin' : 'fa-save'"></i>Save
            </button>
        </form>

        <div v-if="!entrypoints.length">
            Er zijn nog geen entrypoints gedefinieerd voor deze scraper.
        </div>
        <table v-else class="w-full whitespace-no-wrap bg-white rounded shadow">
            <thead>
                <tr class="text-teal-800 font-bold">
                    <th class="px-4 py-4 text-left"><i class="fad fa-calendar-alt mr-1"></i>url</th>
                    <th class="px-4 py-4 text-left">&nbsp;</th>
                </tr>
            </thead>

            <tr
                v-for="(entrypoint, index) in entrypoints"
                class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900"
                :class="!(index % 2) ? 'bg-teal-100' : ''"
            >
                <td class="px-3 py-4 border-t text-left">
                    {{ entrypoint.url }}
                </td>
                <td class="px-3 py-4 border-t text-center">
                    <button @click="deleteEntrypoint(entrypoint)" class="px-3 py-1 rounded inline-block hover:bg-red-300 focus:bg-red-300">
                        <i class="fal" :class="loading == 'deleteEntrypoint' + entrypoint.id ? 'fa-spinner fa-spin' : 'fa-trash'"></i>
                    </button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import _ from "lodash";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import TextInput from "@/admin/Shared/TextInput";

export default {
    mixins: [Helpers],

    components: { TextInput },

    props: {
        scraper: {},
        entrypoints: Array
    },

    data() {
        return {
            showForm: false,
            form: {
                url: ""
            }
        };
    },

    methods: {
        submitEntrypoint() {
            this.loading = "submitEntrypoint";
            const url = this.route("admin.scrapers.entrypoints.store", this.scraper.id);
            this.$inertia.post(url, this.form).then(() => {
                this.loading = false;
                if (!this.$page.props.errors.url) {
                    this.form.url = "";
                    this.showForm = false;
                }
            });
        },

        deleteEntrypoint(entrypoint) {
            const url = this.route("admin.scrapers.entrypoints.destroy", [this.scraper.id, entrypoint.id]).url();
            this.loading = "deleteEntrypoint" + entrypoint.id;
            this.$inertia.delete(url).then(() => {
                this.loading = "";
            });
        }
    }
};
</script>
